import axios, { AxiosError } from 'axios'
import { createContext, useCallback, useState } from 'react'
import { RequestError } from '../types'

type ApiErrorBody = {
  message?: string
  errors?: string[]
}

const ErrorsContext = createContext<{
  errors: RequestError[]
  addError?: (error: unknown) => void
  resetErrors?: (er?: RequestError) => void
}>({ errors: [] })

const ErrorsProvider = ({ children }) => {
  const [errors, setErrors] = useState<RequestError[]>([])

  const addError = useCallback((error: unknown) => {
    if (axios.isCancel(error)) return
    if (!axios.isAxiosError<ApiErrorBody>(error)) return
    if (error.code === AxiosError.ERR_CANCELED) return

    const errorJson = error.toJSON() as { code?: string, message?: string }

    const parsedCode = /^\d+$/.test(errorJson.code ?? '') ? parseInt(errorJson.code ?? '', 10) : undefined

    const errorRes: RequestError = {
      statusCode: error.response?.status ?? parsedCode,
      message: error.response?.data?.message ?? errorJson.message,
      errors: error.response?.data?.errors,
    }

    setErrors(e => [...e ?? [], errorRes])
  }, [])

  const resetErrors = useCallback((er: RequestError|undefined) => {
    if (er) {
      setErrors(e => e.filter(e2 => e2 !== er))
    } else {
      setErrors([])
    }
  }, [])

  return (
    <ErrorsContext.Provider value={ { errors, addError, resetErrors } }>
      { children }
    </ErrorsContext.Provider>
  )
}

export { ErrorsProvider, ErrorsContext }
